module.exports = __webpack_public_path__ + "img/map-marker-blue.d084c5a4.png";